const slider = () => {

    const farmSlider = new Swiper(".swiper", {
        observer: true,
        observeSlideChildren: true,
        updateOnWindowResize: true,
        updateOnWindowResize: true,
        observeParents: true,
        speed: 1000,
        spaceBetween: '2%',
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            320: {
                grid: {
                    rows: 2,
                    fill: "row",
                },
                slidesPerView: 1,
                
            },
            577: {
                grid: {
                    rows: 2,
                    fill: "row",
                },
                slidesPerView: 3,
            }
        }
    })

}

module.exports = slider;